import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import "../../../styles/DetailBrowser.css";
import "react-calendar/dist/Calendar.css";
import {
  useFetchQueTypes,
  useFetchAudCycles,
} from "../../../utils/hooks/UseFetchUrl";
import {
  useFetchAuditstores,
  useFetchReportAttributes,
} from "../../../utils/hooks/ReportHook";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectContext from "../../../utils/Context/SelectContext";
import {
  DatePicker,
  Dropdown,
  Menu,
  Select,
  Spin,
  message,
  Tooltip,
} from "antd";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import ScrollDown from "../../../components/ScrollDown";
import moment from "moment/moment";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { base_url } from "../../../utils/apiConfig";
import newStyled from "@emotion/styled";
import { debounce } from "lodash";
import useTenant from "../../../utils/hooks/useTenant";
import { useTenantContext } from "../../../utils/Context/TenantsContext";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const SectionBrowser = ({ questionnaireType, auditTypeId }) => {
  const context = useContext(SelectContext);
  const location = useLocation();
  const navState = location.state;
  const navigate = useNavigate();
  const tenant = useTenant();
  const { name: tenantName } = useTenantContext();

  const {
    selectedOption,
    setSelectedOption,
    selectedOption1,
    setSelectedOption1,
    selectedQueId,
    setSelectedQueId,
    flag,
    setFlag,
  } = context;
  const { data: queTypesData } = useFetchQueTypes(
    "/questionnaire_types_for_dashboard",
  );
  const { data: cyclesData } = useFetchAudCycles("/audit_cycle_for_dashboard");
  const {
    data: storesData,
    isLoading,
    getApiData: getstoresApiData,
  } = useFetchAuditstores();

  const allSections = useMemo(() => {
    const map = new Map();
    storesData.forEach((store) =>
      store.sections?.forEach((s) => {
        if (!map.has(s.section)) map.set(s.section, s.sequence);
      }),
    );
    return [...map.entries()].sort((a, b) => a[1] - b[1]).map(([name]) => name);
  }, [storesData]);

  const { data: reportAttData, getApiData: getreportAttApiData } =
    useFetchReportAttributes();
  const queId = queTypesData?.[0]?.id;
  const [cycleId, setCycleId] = useState(null);
  const [detailsData, setDetailsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState(null);
  const [datesManuallySet, setDatesManuallySet] = useState(false);

  const fetchApis = useCallback(
    debounce((selectedQueId, cycleId) => {
      if (selectedQueId && cycleId) {
        getstoresApiData(`/report/audit_cycle/${cycleId}/audit_store`);
        getreportAttApiData(`/audit_cycle/${cycleId}/report_attribute`);
      }
    }, 500),
    [],
  );

  useEffect(() => {
    if (navState && cycleId != null) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [cycleId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!navState?.questionnaireTypeId) return;
    setSelectedQueId(navState.questionnaireTypeId);
    setSelectedOption(navState.questionnaireTypeId);
  }, [navState]);

  useEffect(() => {
    if (cyclesData && selectedQueId) {
      const filteredCycles = cyclesData.filter(
        (cycle) => cycle.questionnaire_type.id === selectedQueId,
      );
      setDetailsData(filteredCycles);

      if (filteredCycles.length > 0) {
        const navCycleId = navState?.auditCycleId;
        const navCycleIsValid =
          navCycleId != null && filteredCycles.some((c) => c.id === navCycleId);

        const targetCycleId = navCycleIsValid
          ? navCycleId
          : filteredCycles[0].id;
        setCycleId(targetCycleId);
        if (navCycleIsValid) {
          setSelectedOption1(navCycleId);
        }
      } else {
        setCycleId(null);
      }
    }
  }, [cyclesData, selectedQueId, navState]);

  useEffect(() => {
    if (selectedQueId && cycleId) {
      fetchApis(selectedQueId, cycleId);
    }
  }, [selectedQueId, cycleId, fetchApis]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    if (queId && flag) {
      setSelectedQueId(queId);
      setFlag(false);
    }
  }, [queId]);

  const [value] = useState(new Date());
  const [openDropdown, setOpenDropdown] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filters, setFilters] = useState({
    state: "",
    city: "",
    startDate: null,
    endDate: null,
  });
  const [openFilter, setOpenFilter] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleSelectChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    setSelectedQueId(selectedId);
    setSelectedOption(selectedId);
    const relatedAuditCycles = detailsData?.filter(
      (item) => item.questionnaireId === selectedId,
    );

    if (relatedAuditCycles.length > 0) {
      const newAuditCycle = relatedAuditCycles[0].id;
      setSelectedOption1(newAuditCycle);
    }
  };

  const handleSelectChange1 = (event) => {
    const selectedId1 = parseInt(event.target.value, 10);
    setSelectedOption1(event.target.value);
    getstoresApiData(`/report/audit_cycle/${selectedId1}/audit_store`);
  };
  const states = [...new Set(storesData.map((store) => store.state))];
  const allCities = [...new Set(storesData.map((store) => store.city_name))];
  const citiesByState = storesData.reduce((acc, store) => {
    if (!acc[store.state]) acc[store.state] = [];
    if (!acc[store.state].includes(store.city_name))
      acc[store.state].push(store.city_name);
    return acc;
  }, {});
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [filteredStores, setFilteredStores] = useState([]);
  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setSelectedCity("");
  };
  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
  };
  useEffect(() => {
    if (filteredStores.length === 0) {
      setStartDate(null);
      setEndDate(null);
      setFilters((prev) => ({ ...prev, startDate: null, endDate: null }));
      return;
    }
    const filteredDates = filteredStores.map((store) =>
      dayjs(store.audit_date),
    );
    const minDate = dayjs(Math.min(...filteredDates.map((d) => d.valueOf())));
    const maxDate = dayjs(Math.max(...filteredDates.map((d) => d.valueOf())));
    setStartDate(minDate);
    setEndDate(maxDate);
  }, [filteredStores]);
  useEffect(() => {
    const updatedFilteredStores = storesData
      .filter((store) => {
        const isStateMatch = selectedState
          ? store.state === selectedState
          : true;
        const isCityMatch = selectedCity
          ? store.city_name === selectedCity
          : true;
        const auditDate = dayjs(store.audit_date);
        const start = selectedStartDate ? dayjs(selectedStartDate) : null;
        const end = selectedEndDate ? dayjs(selectedEndDate) : null;

        const isDateMatch =
          (!start ||
            auditDate.isSame(start, "day") ||
            auditDate.isAfter(start)) &&
          (!end || auditDate.isSame(end, "day") || auditDate.isBefore(end));

        return isStateMatch && isCityMatch && isDateMatch;
      })
      .sort((a, b) => dayjs(a.audit_date).diff(dayjs(b.audit_date)));

    if (selectedStartDate === "" || selectedEndDate === "") {
      if (updatedFilteredStores.length > 0) {
        const filteredDates = updatedFilteredStores.map((store) =>
          dayjs(store.audit_date),
        );
        const minDate = dayjs(
          Math.min(...filteredDates.map((d) => d.valueOf())),
        );
        const maxDate = dayjs(
          Math.max(...filteredDates.map((d) => d.valueOf())),
        );
        setSelectedStartDate(minDate);
        setSelectedEndDate(maxDate);
      }
    }
    setFilteredStores(updatedFilteredStores);
  }, [
    storesData,
    selectedState,
    selectedCity,
    selectedStartDate,
    selectedEndDate,
  ]);

  const handleSortToggle = () => {
    setSortOrder((prev) =>
      prev === null ? "asc" : prev === "asc" ? "desc" : null,
    );
  };
  // const finalFilteredStores = filteredStores;
  const finalFilteredStores = sortOrder
    ? [...filteredStores].sort((a, b) => {
        const aVal = a.total_score?.percentage ?? -1;
        const bVal = b.total_score?.percentage ?? -1;
        return sortOrder === "asc" ? aVal - bVal : bVal - aVal;
      })
    : filteredStores;

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
    if (field === "state") {
      setSelectedState(value);
      setSelectedCity(null);
      if (!datesManuallySet) {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
      }
    } else if (field === "city") {
      setSelectedCity(value);
      if (!datesManuallySet) {
        setSelectedStartDate(null);
        setSelectedEndDate(null);
      }
    } else if (field === "startDate") {
      setSelectedStartDate(value);
      setDatesManuallySet(true);
    } else if (field === "endDate") {
      setSelectedEndDate(value);
      setDatesManuallySet(true);
    }
  };
  const handleClearFilters = () => {
    setSelectedState(null);
    setSelectedCity(null);
    setStartDate(null);
    setEndDate(null);
    setSelectedOption1(null);
    setOpenDropdown(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSortOrder(null);
    setDatesManuallySet(false);
    getstoresApiData(`/report/audit_cycle/${cycleId}/audit_store`);
  };
  const getColor = (color) =>
    color === 4
      ? "#eaff99"
      : color === 5
        ? "#c1ff99"
        : color === 2
          ? "#ffeb99"
          : color === 1
            ? "#ffc299"
            : color === 3
              ? "#ff9"
              : "#ffffff";

  const auditCycleIdName = selectedOption1 || detailsData?.[0]?.id || "";
  const auditCycle = detailsData?.find(
    (cycle) => cycle.id === Number(auditCycleIdName),
  );

  const cycleName = auditCycle?.name
    ? auditCycle.name.replace(/\s+/g, "_")
    : "Unknown_Cycle";

  const downloadSummaryAsExcel = async ({
    auditCycle,
    cityId,
    state,
    country,
    storeType,
    storePriority,
    startDate,
    endDate,
    reportAttributes,
  }) => {
    if (!auditCycle || !auditCycle.id) return;
    // let base = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_cycle/${auditCycle.id}/report_browser_filtered_xlsx_report?`;
    // base += "city=" + encodeURIComponent(cityId || "");
    // base += "&state=" + encodeURIComponent(state || "");
    // base += "&country=" + encodeURIComponent(country || "");
    // base += "&priority=" + encodeURIComponent(storePriority || "");
    // base += "&start_date=" + encodeURIComponent(startDate || "");
    // base += "&end_date=" + encodeURIComponent(endDate || "");
    // base += "&type=" + encodeURIComponent(storeType || "");

    let base = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_cycle/${auditCycle.id}/section_browser_filtered_xlsx_report`;
    if (reportAttributes) {
      for (let jsonId in reportAttributes) {
        base +=
          "&attribute=" +
          encodeURIComponent(jsonId + ":" + reportAttributes[jsonId]);
      }
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(base, {
        method: "GET",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Authorization: `token ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching Excel: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // a.download = `Summary_Report_${auditCycle.id}.xlsx`;
      a.download = `${cycleName}_Id_${auditCycle.id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.log("Something went wrong downloading Summary Excel file", error);
    }
  };

  const downloadDetailsAsExcel = async ({
    auditCycle,
    cityId,
    state,
    country,
    storePriority,
    storeType,
    reportAttributes,
  }) => {
    const auditCycleId = auditCycle?.id || selectedOption1;

    if (!auditCycleId) {
      console.log("🚨 No valid Type of Audit ID found!");
      return;
    }
    const apiUrl = `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_cycle/${auditCycleId}/audit_cycle_filtered_xlsx_report?`;

    let base = apiUrl;
    base += "city=" + encodeURIComponent(cityId || "");
    base += "&state=" + encodeURIComponent(state || "");
    base += "&country=" + encodeURIComponent(country || "");
    base += "&priority=" + encodeURIComponent(storePriority || "");
    base += "&type=" + encodeURIComponent(storeType || "");

    if (reportAttributes) {
      for (let jsonId in reportAttributes) {
        base +=
          "&attribute=" +
          encodeURIComponent(jsonId + ":" + reportAttributes[jsonId]);
      }
    }

    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(base, {
        method: "GET",
        headers: {
          "Content-Type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Authorization: `token ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching Excel: ${response.statusText}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Audit-Browser_${cycleName}_Id_${auditCycleId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.log("🚨 Error downloading Excel file:", error);
    }
  };

  useEffect(() => {
    if (selectedOption) {
      const relatedAuditCycles = detailsData?.filter(
        (item) => item.questionnaireId === selectedOption,
      );
      if (relatedAuditCycles.length > 0) {
        setSelectedOption1(relatedAuditCycles[0].id);
      }
    }
  }, [selectedOption]);

  const menu = (
    <Menu
      items={[
        {
          key: "summary",
          label: (
            <>
              Summary Excel <br />
              <span style={{ fontSize: "14px", color: "#888" }}>
                Download summary of all reports with section-based scores.
              </span>
            </>
          ),
          onClick: () => {
            setLoading(true);
            message.loading("Downloading summary excel, please wait...", 2);
            const auditCycleId = selectedOption1 || detailsData?.[0]?.id || "";
            const questionnaireId =
              selectedOption || queTypesData?.[0]?.id || "";
            downloadSummaryAsExcel({
              auditCycle: { id: auditCycleId },
              cityId: "",
              state: "",
              country: "",
              storeType: "",
              storePriority: "",
              startDate: "",
              endDate: "",
              reportAttributes: {},
            });
            setLoading(false);
          },
        },
        {
          key: "details",
          label: (
            <>
              Detailed Excel <br />
              <span style={{ fontSize: "14px", color: "#888" }}>
                Download all reports with complete answers and commentary.
              </span>
            </>
          ),
          onClick: async () => {
            setLoading(true);
            message.loading("Downloading detailed excel, please wait...", 2);
            const auditCycleId = selectedOption1 || detailsData?.[0]?.id || "";
            const questionnaireId =
              selectedOption || queTypesData?.[0]?.id || "";

            await downloadDetailsAsExcel({
              auditCycle: { id: auditCycleId },
              cityId: "",
              state: "",
              country: "",
              storeType: "",
              storePriority: "",
              startDate: "",
              endDate: "",
              reportAttributes: {},
            });

            setLoading(false);
          },
        },
      ]}
    />
  );

  const dynamicColumns = storesData?.length
    ? storesData[0]?.sections?.map((section, index) => ({
        title: (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
          >
            {section.section}
          </div>
        ),
        dataIndex: `section_${index}`,
        key: `section_${index}`,
        align: "center",
        width: 120,
        ellipsis: true,
        render: (value) =>
          !value || value.percentage === null ? (
            "N/A"
          ) : (
            <div className="progressBarContainer">
              <span>{`${value.percentage}%`}</span>
              <div
                className="dash1RB"
                style={{
                  backgroundColor: getColor(value.color),
                }}
              ></div>
            </div>
          ),
      }))
    : [];

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: 80,
      fixed: "center",
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
      align: "center",
      width: 100,
    },
    {
      title: "Store Code",
      dataIndex: "store_code",
      key: "store_code",
      align: "center",
      width: 60,
    },
    {
      title: "Date",
      dataIndex: "audit_date",
      key: "audit_date",
      align: "center",
      render: (date) => moment(date).format("Do MMM YYYY"),
    },
    {
      title: "Total Marks",
      dataIndex: "total_score",
      key: "total_score",
      align: "center",
      width: 100,
      render: (score) => (
        <div
          className="marksContainerRB"
          style={{
            backgroundColor: getColor(score.color),
            color: "#00000",
          }}
        >
          {score.percentage}%
        </div>
      ),
    },
    ...dynamicColumns,
    {
      title: "Report",
      dataIndex: "audit_store_id",
      key: "audit_store_id",
      align: "center",
      width: 80,
      render: (id) => (
        <Link to={`/auditReport/${id}`} target="_blank">
          <button className="reportBtnRB">View</button>
        </Link>
      ),
    },
  ];

  const dataSource = isLoading
    ? []
    : finalFilteredStores.map((row, index) => ({
        key: index,
        index: index + 1,
        store_name: row.store_name || "N/A",
        city_name: row.city_name || "N/A",
        store_code: row.store_code || "N/A",
        audit_date: row.audit_date,
        total_score: row.total_score,
        audit_store_id: row.audit_store_id,
        ...row.sections.reduce(
          (acc, section, idx) => ({
            ...acc,
            [`section_${idx}`]: section,
          }),
          {},
        ),
      }));

  const SortChevron = () => {
    const baseStyle = {
      display: "inline-flex",
      alignItems: "center",
      marginLeft: "6px",
      cursor: "pointer",
      fontSize: "13px",
      userSelect: "none",
      transition: "color 0.2s ease",
    };

    if (sortOrder === "asc")
      return (
        <Tooltip title="Sorted: Low → High (click for High → Low)">
          <span
            style={{ ...baseStyle, color: "#003d5c", fontWeight: "bold" }}
            onClick={handleSortToggle}
          >
            ↑
          </span>
        </Tooltip>
      );
    if (sortOrder === "desc")
      return (
        <Tooltip title="Sorted: High → Low (click to reset)">
          <span
            style={{ ...baseStyle, color: "#003d5c", fontWeight: "bold" }}
            onClick={handleSortToggle}
          >
            ↓
          </span>
        </Tooltip>
      );
    return (
      <Tooltip title="Click to sort by Total Marks">
        <span
          style={{ ...baseStyle, color: "#aaa" }}
          onClick={handleSortToggle}
        >
          ⇅
        </span>
      </Tooltip>
    );
  };

  return (
    <div
      style={{ minHeight: "800px", width: "100%", maxWidth: "100%" }}
      className="px-2"
    >
      <div className="reportParaHead">
        <p className="my-3">Section Browser</p>
      </div>
      <div className="d-flex flex-wrap justify-content-between align-items-center m-3 responsive-container">
        <div className="d-flex align-items-center gap-3 select-container">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 w-100">
            <div className="d-flex align-items-center gap-1 w-100">
              <p className="RbQuesHeading mb-0">Questionnaire Type:</p>
              <select
                value={selectedOption}
                onChange={handleSelectChange}
                className="selectReport flex-grow-1"
              >
                {queTypesData?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="d-flex align-items-center gap-1 w-100">
              <p className="mb-0 RbQuesHeading">Type of Audit:</p>
              <select
                value={selectedOption1}
                onChange={handleSelectChange1}
                className="selectReport flex-grow-1"
              >
                {detailsData?.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center gap-3 ms-auto action-container">
          <div
            className="filterAudit d-flex align-items-center gap-1"
            onClick={() => setOpenFilter(!openFilter)}
          >
            <p className="filterAuditText my-1">Filter</p>
            <div className="filterAuditIcon">
              <i className="bi bi-filter"></i>
            </div>
          </div>
          <Dropdown overlay={menu} trigger={["click"]}>
            <div className="exportBtnReport d-flex justify-content-center align-items-center">
              <Tooltip title="Export List">
                <VerticalAlignBottomOutlined className="exportIconReport" />
              </Tooltip>
              <p className="export-text my-2">Export List</p>
            </div>
          </Dropdown>
        </div>
      </div>
      {openFilter && (
        <div
          className="filter-box d-flex flex-wrap gap-3 mx-3 my-4"
          style={{ cursor: "pointer" }}
        >
          <SelectState
            showSearch
            placeholder="Select State"
            value={selectedState}
            onChange={(value) => handleFilterChange("state", value)}
            className="custom-input"
            size="medium"
            style={{ minWidth: "160px" }}
          >
            {states
              .slice()
              .sort((a, b) => a.localeCompare(b))
              .map((state) => (
                <Select.Option key={state} value={state}>
                  {state}
                </Select.Option>
              ))}
          </SelectState>
          <SelectCity
            showSearch
            placeholder="Select City"
            value={selectedCity}
            onChange={(value) => handleFilterChange("city", value)}
            className="custom-input"
            size="medium"
            // style={{ minWidth: "3rem" }}
            style={{ minWidth: "160px" }}
          >
            {selectedState
              ? citiesByState[selectedState]?.map((city) => (
                  <Select.Option key={city} value={city}>
                    {city}
                  </Select.Option>
                ))
              : allCities.map((city) => (
                  <Select.Option key={city} value={city}>
                    {city}
                  </Select.Option>
                ))}
          </SelectCity>
          <DatePicker
            placeholder="Start Date"
            value={selectedStartDate}
            onChange={(date) => handleFilterChange("startDate", date)}
            className="custom-input"
            size="medium"
            style={{ minWidth: "140px" }}
          />
          <DatePicker
            placeholder="End Date"
            value={selectedEndDate}
            onChange={(date) => handleFilterChange("endDate", date)}
            className="custom-input"
            size="medium"
            style={{ minWidth: "140px" }}
          />
          <div
            onClick={handleClearFilters}
            className="clearFilterRB d-flex align-items-center"
          >
            <p className="my-1">Clear Filter</p>
          </div>
        </div>
      )}

      <div
        style={{
          fontSize: "1rem",
          fontWeight: "500",
          textAlign: "end",
          fontFamily: "Roboto,sans-serif",
          color: "#003d5c",
        }}
        className="mx-3 mb-3"
      >
        Total Stores: {finalFilteredStores ? finalFilteredStores.length : 0}
      </div>
      <div className="table table-responsive p-3">
        <table id="table-to-exportRB">
          <thead>
            <tr>
              <th
                style={{ backgroundColor: "#f2f2f2", width: "5vw" }}
                className="align-center"
              >
                Sr. no.
              </th>
              <th
                className="align-center"
                style={{ backgroundColor: "#f2f2f2", width: "20vw" }}
              >
                Store Name
              </th>
              {tenantName === "FloorWalk" && (
                <th
                  className="align-center"
                  style={{ width: "9vw", backgroundColor: "#f2f2f2" }}
                >
                  Performance Deviation
                </th>
              )}
              <th
                className="align-center"
                style={{ width: "5vw", backgroundColor: "#f2f2f2" }}
              >
                Store Code
              </th>
              <th
                className="align-center"
                style={{ width: "5vw", backgroundColor: "#f2f2f2" }}
              >
                Date
              </th>
              {/* <th style={{ backgroundColor: "#f2f2f2" }}>Total Marks</th> */}
              <th
                className="align-center"
                style={{ width: "7vw", backgroundColor: "#f2f2f2" }}
              >
                <span>Total Marks</span>
                <SortChevron />
              </th>
              {/* {storesData[0]?.sections.map((section, index) => (
                <th
                  key={index}
                  style={{ backgroundColor: "#f2f2f2" }}
                  className="align-center"
                >
                  <p className="m-1 section-name" title={section.section}>
                    {section.section}
                  </p>
                </th>
              ))} */}
              {allSections.map((name) => (
                <th
                  key={name}
                  style={{ backgroundColor: "#f2f2f2" }}
                  className="align-center"
                >
                  <p className="m-1 section-name" title={name}>
                    {name}
                  </p>
                </th>
              ))}
              <th
                className="align-center"
                style={{ backgroundColor: "#f2f2f2", width: "6vw" }}
              >
                Report
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td
                  colSpan="100%"
                  style={{
                    textAlign: "center",
                    padding: "6rem",
                    height: "10rem",
                    verticalAlign: "middle",
                  }}
                >
                  <Spin size="large" />
                </td>
              </tr>
            ) : (
              finalFilteredStores?.length > 0 &&
              finalFilteredStores.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      rowIndex % 2 === 0 ? "#ffffff" : "rgb(242,242,242)",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      rowIndex % 2 === 0
                        ? "rgb(242,242,242)"
                        : "rgb(242,242,242)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      rowIndex % 2 === 0 ? "#ffffff" : "rgb(242,242,242)")
                  }
                  onClick={() =>
                    window.open(`/auditReport/${row.audit_store_id}`, "_blank")
                  }
                >
                  <td
                    style={{ backgroundColor: "#f2f2f2", width: "5vw" }}
                    className="align-center"
                  >
                    {rowIndex + 1}
                  </td>
                  <td className="align-left customReport-table">
                    <span style={{ fontWeight: "bold" }}>
                      {row.store_name ?? "N/A"}
                    </span>
                    <br />
                    <span style={{ fontSize: "0.95em", color: "#555" }}>
                      {row.city_name ?? ""}
                    </span>
                  </td>
                  {tenantName === "FloorWalk" && (
                    <td className="align-center" style={{ width: "4vw" }}>
                      {row?.performance_deviation ?? "N/A"}
                    </td>
                  )}
                  <td className="align-center" style={{ width: "4vw" }}>
                    {row.store_code ?? "N/A"}
                  </td>
                  <td className="align-center dateStyleRB">
                    {moment(row.audit_date).format("Do MMM YYYY")}
                  </td>
                  <td>
                    <div
                      className="marksContainerRB"
                      style={{
                        backgroundColor: getColor(row.total_score.color),
                        color: "#000",
                      }}
                    >
                      {row.total_score.percentage}%
                    </div>
                  </td>
                  {/* {row.sections.map((section, sectionIndex) => (
                    <td key={sectionIndex}>
                      <div className="progressBarContainer">
                        <span>
                          {section.percentage == null
                            ? "N/A"
                            : section.percentage === "NA"
                              ? "N/A"
                              : `${section.percentage}%`}
                        </span>
                        <div
                          className={`dash1RB ${section.percentage === null ? "d-none" : ""}`}
                          style={{ backgroundColor: getColor(section.color) }}
                        ></div>
                      </div>
                    </td>
                  ))} */}
                  {allSections.map((name) => {
                    const section = row.sections.find(
                      (s) => s.section === name,
                    );
                    const isNA =
                      !section ||
                      section.percentage == null ||
                      section.percentage === "NA";
                    return (
                      <td key={name}>
                        <div className="progressBarContainer">
                          <span>{isNA ? "N/A" : `${section.percentage}%`}</span>
                          <div
                            className={`dash1RB ${isNA ? "d-none" : ""}`}
                            style={{
                              backgroundColor: getColor(section?.color),
                            }}
                          ></div>
                        </div>
                      </td>
                    );
                  })}
                  <td className="align-center">
                    <Link
                      to={{
                        pathname: `/auditReport/${row.audit_store_id}`,
                        state: { selectedOption: selectedOption },
                      }}
                      target="_blank"
                    >
                      <button className="reportBtnRB">View</button>
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <ScrollDown />
    </div>
  );
};

const SelectState = newStyled(Select)`
:where(.css-dev-only-do-not-override-1kf000u).ant-select-single {
     width: 10rem !important;
    }
@media (max-width: 475px) {
    :where(.css-dev-only-do-not-override-1kf000u).ant-select-single.ant-select-lg {
      width: 100% !important; 
    }
      :where(.css-1kf000u).ant-select-single.ant-select-sm {
    width: 100% !important;
  }
    :where(.css-dev-only-do-not-override-1kf000u).ant-select-single {
     width: 100% !important;
    }
`;
const SelectCity = newStyled(Select)`
:where(.css-dev-only-do-not-override-1kf000u).ant-select-single {
     width: 8rem !important;
    }
@media (max-width: 475px) {
    :where(.css-dev-only-do-not-override-1kf000u).ant-select-single.ant-select-lg {
      width: 100% !important;
    }
   :where(.css-1kf000u).ant-select-single.ant-select-sm {
    width: 100% !important;
  }
    :where(.css-dev-only-do-not-override-1kf000u).ant-select-single {
     width: 100% !important;
    }
  }
`;

export default SectionBrowser;
